import React from 'react'


class ArrowNavHOC extends React.Component {

/*
constructor(props) {
super(props)
this.state = {}

}
*/

render () {
  return (
    <div className="fineryArrow" onClick={this.props.onClickHandler}></div>
  )
}

}


export default ArrowNavHOC


// WEBPACK FOOTER //
// ./src/components/ArrowNavHOC.js